// =====================================
//
//   廣告 相關功能 Service
//   Author: Gray
//   createtime: 2016 / 03 / 02
//   updatetime: 2016 / 03 / 02
//
// =====================================
window.InifECShared.factory("AdblockService", ['$q', '$http', 'Upload', function($q, $http, Upload) {

    var factory = {};

    // --------------------------------
    // 取得首頁Banner廣告
    // --------------------------------
    var getIndexADRotion = function() {

        if(factory.adblockCache["getIndexADRotion"]) {
            return factory.adblockCache["getIndexADRotion"].promise;
        }

        factory.adblockCache["getIndexADRotion"] = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/ADAction.do",
            method: "GET",
            params: {
                op: "getIndexADRotion"
            },
            withCredentials: true
        }).success(function(data){
            if(data.error){
                factory.adblockCache["getIndexADRotion"].reject(data.error);
            } else {
                var adblockList = checkAdblockDisplayTime(data);

                factory.adblockCache["getIndexADRotion"].resolve(adblockList);
            }            
        }).error(function (data, status, headers, config){
            factory.adblockCache["getIndexADRotion"].reject(data);
            console.error("[InifEC Error] : AdblockService.getIndexADRotion request error.");
            console.error("status : " + status);
        });

        return factory.adblockCache["getIndexADRotion"].promise;
    }

    // --------------------------------
    // 取得搜尋關鍵字廣告
    // --------------------------------
    var getSearchingTextAd = function() {

        if(factory.adblockCache["getSearchingTextAd"]) {
            return factory.adblockCache["getSearchingTextAd"].promise;
        }

        factory.adblockCache["getSearchingTextAd"] = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/ADAction.do",
            method: "GET",
            params: {
                op: "getSearchingTextAd"
            },
            withCredentials: true
        }).success(function(data){
            if(data.error){
                factory.adblockCache["getSearchingTextAd"].reject(data.error);
            } else {
                var adblockList = checkAdblockDisplayTime(data);

                factory.adblockCache["getSearchingTextAd"].resolve(adblockList);
            }            
        }).error(function (data, status, headers, config){
            factory.adblockCache["getSearchingTextAd"].reject(data);
            console.error("[InifEC Error] : AdblockService.getADlist getSearchingTextAd error.");
            console.error("status : " + status);
        });

        return factory.adblockCache["getSearchingTextAd"].promise;
    }

    // --------------------------------
    // 取得商品分類廣告
    // --------------------------------
    var getClassifiedAD = function(mainPdtClassID) {

        var params = {
            op: "getClassifiedAD",
            mainPdtClassID: mainPdtClassID
        },
        cachekey = JSON.stringify(params);

        if(factory.classifiedCache[cachekey]) {
            return factory.classifiedCache[cachekey].promise;
        }

        factory.classifiedCache[cachekey] = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/ADAction.do",
            method: "GET",
            params: params,
            withCredentials: true
        }).success(function(data){
            if(data.error){
                factory.classifiedCache[cachekey].reject(data.error);
            } else {
                var adblockList = checkAdblockDisplayTime(data);

                factory.classifiedCache[cachekey].resolve(adblockList);
            }            
        }).error(function (data, status, headers, config){
            factory.classifiedCache[cachekey].reject(data);
            console.error("[InifEC Error] : AdblockService.getClassifiedAD request error.");
            console.error("status : " + status);
        });

        return factory.classifiedCache[cachekey].promise;
    }

    // --------------------------------
    // 取得所有商品分類廣告
    // --------------------------------
    var getAllClassifiedAD = function() {

        if(factory.adblockCache["getAllClassifiedAD"]) {
            return factory.adblockCache["getAllClassifiedAD"].promise;
        }

        factory.adblockCache["getAllClassifiedAD"] = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/ADAction.do",
            method: "GET",
            params: {
                op: "getAllClassifiedAD",
            },
            withCredentials: true
        }).success(function(data){
            if(data.error){
                factory.adblockCache["getAllClassifiedAD"].reject(data.error);
            } else {
                var result;

                if(data) {
                    result = {};
                    $.map(data, function(value, key) {
                        result[key] = checkAdblockDisplayTime(value);
                    })
                }

                factory.adblockCache["getAllClassifiedAD"].resolve(result);
            }            
        }).error(function (data, status, headers, config){
            factory.adblockCache["getAllClassifiedAD"].reject(data);
            console.error("[InifEC Error] : AdblockService.getAllClassifiedAD request error.");
            console.error("status : " + status);
        });

        return factory.adblockCache["getAllClassifiedAD"].promise;
    }

    // --------------------------------
    // 取得手機版首頁Banner廣告
    // --------------------------------
    var getMobileIndexADRotion = function() {

        if(factory.adblockCache["getMobileIndexADRotion"]) {
            return factory.adblockCache["getMobileIndexADRotion"].promise;
        }

        factory.adblockCache["getMobileIndexADRotion"] = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/ADAction.do",
            method: "GET",
            params: {
                op: "getMobileIndexADRotion"
            },
            withCredentials: true
        }).success(function(data){
            if(data.error){
                factory.adblockCache["getMobileIndexADRotion"].reject(data.error);
            } else {
                var adblockList = checkAdblockDisplayTime(data);

                factory.adblockCache["getMobileIndexADRotion"].resolve(adblockList);
            }            
        }).error(function (data, status, headers, config){
            factory.adblockCache["getMobileIndexADRotion"].reject(data);
            console.error("[InifEC Error] : AdblockService.getMobileIndexADRotion request error.");
            console.error("status : " + status);
        });

        return factory.adblockCache["getMobileIndexADRotion"].promise;
    }

    // --------------------------------
    // 取得首頁區塊廣告
    // --------------------------------
    var getHomeBlockAD = function() {

        if(factory.adblockCache["getHomeBlockAD"]) {
            return factory.adblockCache["getHomeBlockAD"].promise;
        }

        factory.adblockCache["getHomeBlockAD"] = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/ADAction.do",
            method: "GET",
            params: {
                op: "getHomeBlockAD"
            },
            withCredentials: true
        }).success(function(data){
            if(data.error){
                factory.adblockCache["getHomeBlockAD"].reject(data.error);
            } else {
                var adblockList = checkAdblockDisplayTime(data);

                factory.adblockCache["getHomeBlockAD"].resolve(adblockList);
            }            
        }).error(function (data, status, headers, config){
            factory.adblockCache["getHomeBlockAD"].reject(data);
            console.error("[InifEC Error] : AdblockService.getHomeBlockAD request error.");
            console.error("status : " + status);
        });

        return factory.adblockCache["getHomeBlockAD"].promise;
    }

    // --------------------------------
    // [private] 檢查廣告時間，回傳可顯示的廣告
    // --------------------------------
    var checkAdblockDisplayTime = function(adblockList) {

        if(!Array.isArray(adblockList) || adblockList.length == 0) {
            return adblockList;
        }

        var newBlockList = [];
        var now = new Date();
        var nowDay = now.getDay();
        var nowHours = now.getHours();
        var nowMinutes = now.getMinutes();
        var nowTime = nowHours * 100 + nowMinutes;
        var startTime;
        var endTime;
        var startDiff;
        var endDiff;

        for(var i = 0; i < adblockList.length; i++) {
            var adblock = adblockList[i];

            if(!adblock.isDisplayWithTime) {
                newBlockList.push(adblock);
            } else {
                startTime = adblock.displayStartTime.replace(":", "");
                endTime = adblock.displayEndTime.replace(":", "");
                startTime = parseInt(startTime, 10);
                endTime = parseInt(endTime, 10);
                
                startDiff = nowTime - startTime;
                endDiff = endTime - nowTime;

                if(startTime > endTime && (startDiff >= 0 || endDiff >= 0)) {
                    newBlockList.push(adblock);
                } else if(startTime < endTime && (startDiff >= 0 && endDiff >= 0)) {
                    newBlockList.push(adblock);
                }
            }
        }

        return newBlockList;
    }

    /*==========================
        Members
    ==========================*/
    factory.adblockCache = {};
    factory.classifiedCache = {};

    /*==========================
        Methods
    ==========================*/
    factory.getIndexADRotion = getIndexADRotion; // 取得首頁Banner廣告
    factory.getSearchingTextAd = getSearchingTextAd; // 取得搜尋關鍵字廣告
    factory.getClassifiedAD = getClassifiedAD; // 取得商品分類廣告
    factory.getAllClassifiedAD = getAllClassifiedAD; // 取得所有商品分類廣告
    factory.getMobileIndexADRotion = getMobileIndexADRotion; // 取得手機版首頁Banner廣告
    factory.getHomeBlockAD = getHomeBlockAD; // 取得首頁區塊廣告

    return factory;
}]);